export function isHtmlEncoded(html) {
    if (!html) return true;
    return !html.match(/[<>]/);
}

export function decodeHtmlEntities(html) {
    if (!html) return html;
    const textarea = document.createElement('textarea');
    textarea.innerHTML = html;
    return textarea.value;
}

// Topic files are uploaded to S3 without a Cache-Control header and a re-uploaded
// topic keeps the exact same URL, so the browser can serve the previous version of
// the topic media. This buster is fixed per page load: switching between topics in
// the same view still uses the browser cache, a reload always picks up new files.
const mediaCacheBuster = Date.now();

export function withMediaCacheBuster(url) {
    if (!url) return url;
    return url + (url.includes("?") ? "&" : "?") + "v=" + mediaCacheBuster;
}
